import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="menu.discover-new-music" defaultMessage="Discover New Music" />
);
